import { render, staticRenderFns } from "./imgMobile.vue?vue&type=template&id=2619b8b2&scoped=true"
import script from "./imgMobile.vue?vue&type=script&lang=js"
export * from "./imgMobile.vue?vue&type=script&lang=js"
import style0 from "./imgMobile.vue?vue&type=style&index=0&id=2619b8b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2619b8b2",
  null
  
)

export default component.exports